const config = {
    api: "https://tapi.tripvaletincentives.com/",
    arriviaDomain: "members297.tripvalet.com",
    arriviaRedirectUrl: " https://members297.tripvalet.com/vacationclub/logincheck.aspx?Token="
}
export default config
